/**
 * A simple method to check whether or not this current system has INTL
 * support. It's possible to support INTL but not have full icu support,
 * so it optionally can check whether INTL and non-English icu is supported.
 * @param {bool} doFullCheck - Whether or not to do a simple INTL or full INTL check
 * @return {bool} Return
 */
export default function supportsIntl(doFullCheck = false) {
  if (!doFullCheck) {
    return typeof Intl === 'object';
  }

  try {
    const january = new Date(9e8);
    const spanish = Intl.DateTimeFormat('es', { month: 'long' });
    return spanish.format(january) === 'enero';
  }
  catch (err) {
    return false;
  }
}
